import React from 'react';
/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const ProhibitionIcon: React.FC<AllieIconProps> = ({ size = 22, color = '#70707B' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 1.75C5.89137 1.75 1.75 5.89137 1.75 11C1.75 13.2514 2.55356 15.314 3.89074 16.9183L17.0592 4.0106C15.4356 2.60171 13.3178 1.75 11 1.75ZM18.1093 5.08174L4.94081 17.9894C6.56438 19.3983 8.68218 20.25 11 20.25C16.1086 20.25 20.25 16.1086 20.25 11C20.25 8.74858 19.4464 6.68604 18.1093 5.08174ZM0.25 11C0.25 5.06294 5.06294 0.25 11 0.25C14.007 0.25 16.7268 1.48564 18.677 3.47497C20.5771 5.41323 21.75 8.07039 21.75 11C21.75 16.9371 16.9371 21.75 11 21.75C7.99296 21.75 5.27316 20.5144 3.32299 18.525C1.42288 16.5868 0.25 13.9296 0.25 11Z"
        fill={color}
      />
    </svg>
  );
};
